import { atom } from 'jotai';
import { BaseImage } from 'types/studio/studio';
import { Steps } from '../BuildBundle.enum';
import { CheckoutBaBType, ProductTypeOption, SubscriptionType } from '../constants';
import type { ProductBaBFinalOption, ProductBaBVariant, SecondStepOption } from '../types';

export const stepAtom = atom<number>(Steps.FIRST_STEP);
export const firstStepOptionAtom = atom<ProductTypeOption>(ProductTypeOption.FIRST_PRODUCT);
export const secondStepOptionAtom = atom<SecondStepOption>({
  product: {} as ProductBaBFinalOption,
  type: CheckoutBaBType.SUBSCRIPTION,
  quantity: 1
});
export const secondStepVariantAtom = atom<ProductBaBVariant | null>(null);
export const checkoutStatusAtom = atom<'idle' | 'loading' | 'success'>('idle');
export const selectedTypeAtom = atom<SubscriptionType | undefined>(undefined);
export const landerUrl = atom<string | undefined>(undefined);

// Derive image based on step and selected options
export const imgAtom = atom<BaseImage | null>((get) => {
  const step = get(stepAtom);
  const selectedType = get(selectedTypeAtom);
  const secondStepVariant = get(secondStepVariantAtom);

  if (step === Steps.FIRST_STEP) {
    // On first step, show the variant's general image
    return secondStepVariant?.generalImage || null;
  }

  // On second step, show the selected product's image based on subscription type
  if (step === Steps.SECOND_STEP && secondStepVariant) {
    switch (selectedType) {
      case SubscriptionType.SINGLE:
        return secondStepVariant.singleSubscription?.imageDesktop || null;
      case SubscriptionType.DOUBLE:
        return secondStepVariant.doubleSubscription?.imageDesktop || null;
      case SubscriptionType.FAMILY_PLAN:
        return secondStepVariant.familySubscription?.imageDesktop || null;
      case SubscriptionType.ONE_TIME:
        return secondStepVariant.oneTime?.imageDesktop || null;
      default:
        return null;
    }
  }

  return null;
});
